<template>
  <px-custom-dialog v-model="dialog"
                    content-class="rounded-card"
                    :width="dialogWidth">
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      Aprovação de compra
      <v-btn class="ml-3" icon link target="_blank" :to="linkAprovacao">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
    <template>
      <px-aprovacao-compra-detalhes is-modal-view
                                    :aprovacao-id-prop="aprovacaoId"
                                    @update="onUpdate"/>
    </template>
  </px-custom-dialog>
</template>

<script>
import AprovacaoCompraDetalhes
  from '@/modules/aprovacao-compra/detalhes/AprovacaoCompraDetalhes.vue';

export default {
  props: {
    aprovacaoId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    linkAprovacao() {
      return `/aprovacao-compra/${this.aprovacaoId}`;
    },
    isSmall() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    dialogWidth() {
      return this.isSmall ? '95%' : '1400px';
    },
  },
  methods: {
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoCompraDetalhes: AprovacaoCompraDetalhes,
  },
};
</script>
